import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RegistrationRoutingModule } from './registration-routing.module';
import { HomeComponent } from './home/home.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { AppointmentComponent } from './appointment/appointment.component';
import { PatientinsuranceComponent } from './patientinsurance/patientinsurance.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
//import { SignaturePadModule } from 'angular2-signaturepad';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';
import { IntakemoduleModule } from '../component/intakemodule/intakemodule.module';
import { PatientpaymenttypeComponent } from './patientpaymenttype/patientpaymenttype.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { PaymentOverviewComponent } from './payment-overview/payment-overview.component';
import { PaymentComponent } from './payment/payment.component';
import { ExitingpatientloginComponent } from './exitingpatientlogin/exitingpatientlogin.component';
import { AppointmentexitingComponent } from './appointmentexiting/appointmentexiting.component';
import { FinalappointmentmessageComponent } from './finalappointmentmessage/finalappointmentmessage.component';
import { ThankyoumessageonappointmentComponent } from './thankyoumessageonappointment/thankyoumessageonappointment.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { RegistrationConsentFormComponent } from './registration-consent-form/registration-consent-form.component';
import { RegistrationFinancialFormComponent } from './registration-financial-form/registration-financial-form.component';
//import { CheckinComponent } from './checkin/checkin.component';
import { ReferralCheckinComponent } from './referral-checkin/referral-checkin.component';
import { ReferralComponent } from './referral/referral.component';
import { StandAloneSchedulerComponent } from './standAloneScheduler/standalonescheduler.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LabComponent } from './lab/lab.component';
@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    AppointmentComponent,
    PatientinsuranceComponent,
    PatientpaymenttypeComponent,
    PaymentOverviewComponent,
    PaymentComponent,
    PaymentFailedComponent,
    ExitingpatientloginComponent,
    AppointmentexitingComponent,
    FinalappointmentmessageComponent,
    ThankyoumessageonappointmentComponent,
    RegistrationConsentFormComponent,
    RegistrationFinancialFormComponent,
    //CheckinComponent,
    ReferralCheckinComponent,
    ReferralComponent,
    LabComponent,
    StandAloneSchedulerComponent,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA], imports: [
    CommonModule,
    RegistrationRoutingModule,
    NgxSpinnerModule,
    FormsModule,
    NgOtpInputModule,
    BrowserModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-full-width',
      preventDuplicates: true,
    }),
    NgMultiSelectDropDownModule.forRoot(),
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatInputModule,
    CarouselModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    //SignaturePadModule,
    IntakemoduleModule,
    NgbModule,
    PdfViewerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [DatePipe, provideHttpClient(withInterceptorsFromDi())]
})
export class RegistrationModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
